import React from 'react';
import { Box, Grid, Typography, Button, useTheme } from '@mui/material';

const FeatureBlock = ({ image, title, description, reverse }) => {
  return (
    <Grid
      container
      spacing={4}
      direction={reverse ? 'row-reverse' : 'row'}
      alignItems="stretch"
      justifyContent="center"
      sx={{
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 4 },
      }}
    >
      {/* Image Side */}
      <Grid item xs={12} md={6}>
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: 2,
          }}
        />
      </Grid>

      {/* Text Side */}
      <Grid item xs={12} md={6}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
          paddingTop='10px'
        >
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, mt: 10 }}>
              {title}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
              {description}
            </Typography>
          </Box>

          <Box mt="auto">
            <Button
              variant="contained"
              component="a"
              href="mailto:info@ar.com.pk"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: '#0055FF',
                color: '#fff',
                '&:hover': {
                  backgroundColor: '#003ECC',
                },
              }}
            >
              GET A QUOTE
            </Button>

          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const FeatureBlockSection = ({ data }) => {
  const blocks = [data.block1, data.block2]; // Add more if needed

  return (
    <Box>
      {blocks.map((block, index) => (
        <FeatureBlock
          key={index}
          image={block.image}
          title={block.title}
          description={block.description}
          reverse={index % 2 === 1}
        />
      ))}
    </Box>
  );
};

export default FeatureBlockSection;
